import React from 'react';
import { Divider, makeStyles, Typography } from '@material-ui/core';

import { theme } from 'config/theme';

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    heading: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 6,
    },
});

interface SectionTitleProps {
    children: React.ReactNode;
}

export default function SectionTitle({ children }: SectionTitleProps) {
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <Typography className={classes.heading}>{children}</Typography>
        </div>
    );
}
